// test1767
(1767 && 0);
